import { getShipmentStatusMeta } from "@/utils/shipmentStatus";

export default function StatusBadge({
  status = "unknown",
  className = "",
}: {
  status?: string;
  className?: string;
}) {
  const { label, badgeClassName } = getShipmentStatusMeta(status);

  return (
    <span title={label} className={`${badgeClassName} ${className}`.trim()}>
      {label}
    </span>
  );
}
